import api from './api';

const BASE = '/daily-rate';

export default {
  get: () =>
    api.get(BASE, { params: { functionCode: 'RATE_VIEW' } }).then(r => r.data),

  update: ({ buyRateUsdHtg, sellRateUsdHtg }) =>
    api.put(BASE, {
      buyRateUsdHtg,
      sellRateUsdHtg,
      functionCode: 'RATE_UPDATE'
    }).then(r => r.data),
}